exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh2[data-v-fd2cc18a] {\n  margin-top: 12px !important;\n  font-weight: normal;\n}\n", ""]);

// exports
